import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerClearPrePaidTxnDetails, triggerPrePaidTxnStatusApiCallSuccess } from 'redux/actions';
import { TRIGGER_PREPAID_TXN_STATUS_API_CALL } from 'redux/actionTypes';
import { apiCall } from 'services';
import { ChangeHistory, CleverTapEvent, CleverTapEventNames } from 'utils';

function* triggerRepaymentStatusApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const ORDER_ID = data['orderId'];
	const PATH = data['path'];
	yield put(triggerPrePaidTxnStatusApiCallSuccess());
	yield put(triggerClearPrePaidTxnDetails());
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.PREPAID_TXN_STATUS + API_CONSTANT.QUERY_PARAMS.ORDER_ID + ORDER_ID,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
		loaderDetails: {
			first_message: 'fetching transaction',
			start_index: 0,
			range: 8,
			second_message: 'details',
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		if (apiData) {
			callback && callback(apiData);
			if (apiData?.status === 'SUCCESS' || apiData?.status === 'PENDING' || apiData?.status === 'FAILURE') {
				localStorage.setItem('txn', 'true');
				if (apiData?.status === 'SUCCESS') {
					CleverTapEvent.send(CleverTapEventNames.EVENTS_NAME.MANDATORY_EVENTS.TRANSACTION_SUCCESS, [
						`txnId: ${apiData?.txnId}`,
						`amount: ${apiData?.amount}`,
						`cashbackAmount: ${apiData?.cashbackAmount}`,
						`cashbackTier: ${apiData?.cashbackTier}`,
						`merchantName: ${apiData?.merchantName}`,
						`status: ${apiData?.status}`,
						`txnMode: ${apiData?.txnMode}`,
						`txnSubType: ${apiData?.txnSubType}`,
						`txnTime: ${apiData?.txnTime}`,
						`af_revenue: ${apiData?.amount}`,
					]);
				}
				yield put(triggerPrePaidTxnStatusApiCallSuccess(apiData));
				PATH && ChangeHistory('push', `/prepaid/txn-status/${PATH}`);
			}
		}
	}
}

export default function* triggerRepaymentStatusApiCallSaga() {
	yield takeEvery(TRIGGER_PREPAID_TXN_STATUS_API_CALL, triggerRepaymentStatusApiCall);
}
